import { useMutation } from '@tanstack/react-query';
import apiClient from '../../lib/apiClient';
import { triggerSnackbar } from '../../provider/SnackbarProvider';
import { updateUserData } from '../../redux/slices/authSlice';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';

const uploadProfilePicture = async ({
  file,
  userId,
}: {
  file: File;
  userId: number;
}) => {
  const formData = new FormData();
  formData.append('patient[profile]', file);

  const response = await apiClient.put(`/patients/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const useUploadProfile = () => {
  const dispatch = useDispatch();
  const {
    mutate: upload,
    isPending,
    status,
  } = useMutation({
    mutationFn: uploadProfilePicture,
    onSuccess: (data) => {
      const userData = data?.data;
      if (userData)
        dispatch(
          updateUserData({
            profile_url: userData.profile_url,
          })
        );
      triggerSnackbar({
        message: 'Your profile picture has been updated!',
        severity: 'success',
      });
      //TODO:
      // queryClient.invalidateQueries({
      //   queryKey: ['patient-profile', userId],
      // })
    },
    onError: (error: AxiosError) => {
      const errResponse = error?.response;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { errors = [] } = errResponse?.data as any || {};
      if (errors && errors.length) {
        triggerSnackbar({
          message: errors[0],
          severity: 'error',
        });
        return;
      }
      triggerSnackbar({
        message: 'Failed to upload profile picture. Please try again.',
        severity: 'error',
      });
    },
  });

  const uploadPicture = ({ file, userId }: { file: File; userId: number }) => {
    const validTypes = ['image/png', 'image/jpeg'];
    if (validTypes.includes(file?.type)) {
      upload({
        file,
        userId,
      });
    } else {
      triggerSnackbar({
        message: 'Invalid file type. Only .png and .jpg formats are allowed.',
        severity: 'error',
      });
    }
  };

  return {
    mutate: uploadPicture,
    isPending,
    status,
  };
};
